// Generated by BUCKLESCRIPT VERSION 2.2.3, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css/lib/js/src/Css.js");
var Curry = require("bs-platform/lib/js/curry.js");
var Theme = require("./theme");
var React = require("react");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

var dashboard = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.flexDirection(Css.column),
          /* :: */[
            Css.alignItems(Css.center),
            /* [] */0
          ]
        ]
      ]
    ]);

var modal = Css.style(/* :: */[
      Css.position(/* fixed */10615156),
      /* :: */[
        Css.zIndex(3),
        /* :: */[
          Css.left(Css.px(0)),
          /* :: */[
            Css.top(Css.px(0)),
            /* :: */[
              Css.width(/* `percent */[
                    -119887163,
                    100.0
                  ]),
              /* :: */[
                Css.height(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.overflow(/* auto */-1065951377),
                  /* :: */[
                    Css.backgroundColor(Css.rgb(68, 68, 68)),
                    /* :: */[
                      Css.opacity(50.0),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var flexList = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.display(Css.flexBox),
        /* :: */[
          Css.zIndex(4),
          /* :: */[
            Css.flexDirection(Css.column),
            /* :: */[
              Css.alignItems(Css.center),
              /* :: */[
                Css.background(Css.white),
                /* :: */[
                  Css.marginTop(Css.px(100)),
                  /* :: */[
                    Css.marginLeft(/* auto */-1065951377),
                    /* :: */[
                      Css.marginRight(/* auto */-1065951377),
                      /* :: */[
                        Css.width(/* `percent */[
                              -119887163,
                              80.0
                            ]),
                        /* :: */[
                          Css.maxWidth(Css.px(360)),
                          /* :: */[
                            Css.minWidth(Css.px(260)),
                            /* :: */[
                              Css.maxHeight(Css.px(160)),
                              /* :: */[
                                Css.borderRadius(Css.px(10)),
                                /* [] */0
                              ]
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var headerBox = Css.style(/* :: */[
      Css.textAlign(Css.center),
      /* :: */[
        Css.background(/* `hex */[
              5194459,
              "FFFAFA"
            ]),
        /* :: */[
          Css.display(Css.flexBox),
          /* :: */[
            Css.alignItems(Css.center),
            /* :: */[
              Css.flexDirection(Css.column),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.borderBottom(Css.px(2), /* solid */12956715, Css.hex("FCEBEC")),
                  /* :: */[
                    Css.flexShrink(0),
                    /* [] */0
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader = Css.style(/* :: */[
      Css.fontSize(Css.px(24)),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "FF328C"
            ]),
        /* :: */[
          Css.lineHeight(1.1),
          /* :: */[
            Css.fontWeight(700),
            /* :: */[
              Css.textTransform(Css.uppercase),
              /* :: */[
                Css.margin4(Css.px(10), Css.px(0), Css.px(0), Css.px(0)),
                /* [] */0
              ]
            ]
          ]
        ]
      ]
    ]);

var selectHeader2 = Css.style(/* :: */[
      Css.fontSize(Css.px(16)),
      /* :: */[
        Css.color(/* `hex */[
              5194459,
              "FF328C"
            ]),
        /* :: */[
          Css.margin4(Css.px(2), Css.px(0), Css.px(4), Css.px(0)),
          /* [] */0
        ]
      ]
    ]);

var contentBox = Css.style(/* :: */[
      Css.display(Css.flexBox),
      /* :: */[
        Css.alignItems(Css.center),
        /* :: */[
          Css.flexDirection(Css.row),
          /* :: */[
            Css.top(Css.px(0)),
            /* :: */[
              Css.left(Css.px(0)),
              /* :: */[
                Css.width(/* `percent */[
                      -119887163,
                      100.0
                    ]),
                /* :: */[
                  Css.height(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.overflow(/* auto */-1065951377),
                    /* :: */[
                      Css.justifyContent(/* spaceAround */-485895757),
                      /* [] */0
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var spanEl = Css.style(/* :: */[
      Css.marginLeft(Css.px(6)),
      /* :: */[
        Css.fontWeight(400),
        /* [] */0
      ]
    ]);

var entry = Css.style(/* :: */[
      Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(0)),
      /* :: */[
        Css.cursor(/* pointer */-786317123),
        /* :: */[
          Css.fontSize(Css.px(18)),
          /* :: */[
            Css.background(/* `hex */[
                  5194459,
                  "FFFAFA"
                ]),
            /* :: */[
              Css.fontWeight(400),
              /* :: */[
                Css.flexDirection(Css.row),
                /* :: */[
                  Css.alignItems(Css.center),
                  /* :: */[
                    Css.justifyContent(/* spaceAround */-485895757),
                    /* :: */[
                      Css.width(/* `percent */[
                            -119887163,
                            100.0
                          ]),
                      /* :: */[
                        Css.flexShrink(0),
                        /* [] */0
                      ]
                    ]
                  ]
                ]
              ]
            ]
          ]
        ]
      ]
    ]);

var entryText = Css.style(/* :: */[
      Css.textAlign(/* left */-944764921),
      /* :: */[
        Css.margin4(Css.px(0), Css.px(0), Css.px(0), Css.px(14)),
        /* :: */[
          Css.color(Css.hex("3D2D34")),
          /* [] */0
        ]
      ]
    ]);

function smallerRedSecondaryButton() {
  return Css.style(/* :: */[
              Css.minWidth(Css.px(100)),
              /* :: */[
                Css.maxWidth(Css.px(140)),
                /* :: */[
                  Css.width(/* `percent */[
                        -119887163,
                        100.0
                      ]),
                  /* :: */[
                    Css.height(Css.px(35)),
                    /* :: */[
                      Css.color(/* `hex */[
                            5194459,
                            "FF328C"
                          ]),
                      /* :: */[
                        Css.margin4(Css.px(10), Css.px(8), Css.px(10), Css.px(8)),
                        /* :: */[
                          Css.border(Css.px(1), /* solid */12956715, /* `hex */[
                                5194459,
                                "FF328C"
                              ]),
                          Theme.redButtonNarrowRaw
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

var Styles = /* module */[
  /* dashboard */dashboard,
  /* modal */modal,
  /* flexList */flexList,
  /* headerBox */headerBox,
  /* selectHeader */selectHeader,
  /* selectHeader2 */selectHeader2,
  /* contentBox */contentBox,
  /* spanEl */spanEl,
  /* entry */entry,
  /* entryText */entryText,
  /* smallerRedSecondaryButton */smallerRedSecondaryButton
];

function text(prim) {
  return prim;
}

var component = ReasonReact.statelessComponent("Modal");

function make(onClose, onSelect, _) {
  var handleCloseClick = function (_, _$1) {
    return Curry._1(onClose, /* () */0);
  };
  var newrecord = component.slice();
  newrecord[/* didMount */4] = (function () {
      return /* NoUpdate */0;
    });
  newrecord[/* render */9] = (function (self) {
      return React.createElement("div", {
                  className: modal,
                  onClick: Curry._1(self[/* handle */0], handleCloseClick)
                }, React.createElement("div", {
                      className: flexList,
                      onClick: (function ($$event) {
                          $$event.stopPropagation();
                          return /* () */0;
                        })
                    }, React.createElement("div", {
                          className: headerBox
                        }, React.createElement("div", {
                              className: selectHeader
                            }, "Logout"), React.createElement("div", {
                              className: selectHeader2
                            }, "Möchtest du dich wirklich ausloggen?")), React.createElement("div", {
                          className: contentBox
                        }, React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: (function () {
                                  return Curry._1(onClose, /* () */0);
                                })
                            }, "Nein"), React.createElement("button", {
                              className: smallerRedSecondaryButton(/* () */0),
                              onClick: Curry._1(self[/* handle */0], (function (_, _$1) {
                                      return Curry._1(onSelect, "dd");
                                    }))
                            }, "Ja"))));
    });
  return newrecord;
}

exports.Styles = Styles;
exports.text = text;
exports.component = component;
exports.make = make;
/* dashboard Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/logoutModal.re
// module id = 145
// module chunks = 0